module.exports = __webpack_public_path__ + "img/zxjs.8b2c90f0.png";